import React from 'react';
import './header.css';
import Logo from './Logo';
import Nav from './Nav';

function Header({ onLogout }) {
  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      {/* {logo} */}
      <Logo />

      {/* {nav} */}
      <Nav onLogout={onLogout} />
    </header>
  );
}

export default Header;
